import { useState, useEffect, useCallback } from 'react'
import { agentesApi } from '../api/rrhh'

const vacio = () => ({ legajo: '', nombre: '', codigo_presea: '', activo: true })

export default function AgentesPage() {
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [q, setQ] = useState('')
  const [modal, setModal] = useState(null)   // 'new' | row
  const [form, setForm] = useState(vacio())
  const [err, setErr] = useState('')

  const cargar = useCallback(() => {
    setLoading(true)
    agentesApi.listar(q ? { q } : {})
      .then(({ data }) => setRows(data))
      .catch(() => setErr('No se pudo cargar.'))
      .finally(() => setLoading(false))
  }, [q])
  useEffect(() => { cargar() }, [cargar])

  const openNew = () => { setForm(vacio()); setErr(''); setModal('new') }
  const openEdit = (r) => { setForm({ legajo: r.legajo, nombre: r.nombre, codigo_presea: r.codigo_presea || '', activo: r.activo }); setErr(''); setModal(r) }

  const guardar = async (e) => {
    e.preventDefault(); setErr('')
    const payload = { ...form, legajo: form.legajo.trim(), nombre: form.nombre.trim(), codigo_presea: form.codigo_presea.trim() || null }
    try {
      if (modal === 'new') await agentesApi.crear(payload)
      else await agentesApi.actualizar(modal.id, payload)
      setModal(null); cargar()
    } catch (error) {
      const errs = error.response?.data?.errors
      setErr(errs ? Object.values(errs).flat().join(' ') : (error.response?.data?.message || 'Error al guardar'))
    }
  }

  const eliminar = async (r) => {
    if (!confirm(`¿Eliminar al agente ${r.legajo} - ${r.nombre}?`)) return
    try { await agentesApi.eliminar(r.id); cargar() } catch { alert('No se pudo eliminar') }
  }

  return (
    <div style={{ maxWidth: 760 }}>
      <div style={st.head}>
        <h2 style={st.title}>Agentes</h2>
        <button style={st.primary} onClick={openNew}>+ Nuevo agente</button>
      </div>
      <p style={st.sub}>Base de empleados (legajo + nombre). Los coeficientes y pagadores se cargan en el tablero de SueAdic, no acá.</p>

      <input style={st.search} placeholder="Buscar por legajo o nombre…" value={q} onChange={e => setQ(e.target.value)} />

      {loading ? <p style={{ color: '#94a3b8' }}>Cargando…</p> : (
        <table style={st.table}>
          <thead><tr>
            <th style={st.th}>Legajo</th><th style={{ ...st.th, textAlign: 'left' }}>Nombre</th>
            <th style={st.th}>Cód. Presea</th><th style={st.th}>Activo</th><th style={st.th}></th>
          </tr></thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.id} style={st.tr}>
                <td style={st.tdC}><code>{r.legajo}</code></td>
                <td style={st.td}>{r.nombre}</td>
                <td style={st.tdC}>{r.codigo_presea || <span style={{ color: '#cbd5e1' }}>—</span>}</td>
                <td style={st.tdC}>{r.activo ? 'Sí' : 'No'}</td>
                <td style={st.tdC}>
                  <button style={st.linkBtn} onClick={() => openEdit(r)}>Editar</button>
                  <button style={{ ...st.linkBtn, color: '#dc2626' }} onClick={() => eliminar(r)}>Eliminar</button>
                </td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={5} style={{ ...st.tdC, color: '#94a3b8', padding: '1.5rem' }}>Sin agentes.</td></tr>}
          </tbody>
        </table>
      )}

      {modal && (
        <div style={st.overlay}>
          <div style={st.sheet} onClick={e => e.stopPropagation()}>
            <h3 style={{ marginTop: 0 }}>{modal === 'new' ? 'Nuevo agente' : `Editar — ${modal.legajo}`}</h3>
            <form onSubmit={guardar}>
              <label style={st.lbl}>Legajo *</label>
              <input style={st.inp} value={form.legajo} onChange={e => setForm(f => ({ ...f, legajo: e.target.value }))} required />
              <label style={st.lbl}>Nombre *</label>
              <input style={st.inp} value={form.nombre} onChange={e => setForm(f => ({ ...f, nombre: e.target.value }))} required />
              <label style={st.lbl}>Código Presea</label>
              <input style={st.inp} value={form.codigo_presea} onChange={e => setForm(f => ({ ...f, codigo_presea: e.target.value }))} />
              <label style={st.check}><input type="checkbox" checked={form.activo} onChange={e => setForm(f => ({ ...f, activo: e.target.checked }))} /> Activo</label>
              {err && <p style={st.err}>{err}</p>}
              <div style={st.actions}>
                <button type="button" style={st.cancel} onClick={() => setModal(null)}>Cancelar</button>
                <button type="submit" style={st.primary}>Guardar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}

const st = {
  head: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  title: { margin: 0, fontSize: '1.4rem', fontWeight: 700, color: '#1e293b' },
  sub: { color: '#64748b', fontSize: '0.9rem', margin: '0.4rem 0 0.8rem' },
  search: { width: '100%', maxWidth: 360, padding: '0.5rem 0.7rem', border: '1px solid #d1d5db', borderRadius: 8, marginBottom: '1rem', boxSizing: 'border-box' },
  table: { width: '100%', borderCollapse: 'collapse', background: 'white', borderRadius: 10, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' },
  th: { padding: '0.6rem', background: '#f8fafc', borderBottom: '1px solid #e2e8f0', fontSize: '0.78rem', color: '#475569', textAlign: 'center' },
  tr: { borderBottom: '1px solid #f1f5f9' },
  td: { padding: '0.55rem 0.7rem', fontSize: '0.9rem' },
  tdC: { padding: '0.55rem 0.7rem', fontSize: '0.9rem', textAlign: 'center' },
  linkBtn: { background: 'none', border: 'none', color: '#1e40af', cursor: 'pointer', fontWeight: 600, fontSize: '0.82rem', margin: '0 4px' },
  primary: { background: '#1e40af', color: 'white', border: 'none', borderRadius: 8, padding: '0.5rem 1rem', fontWeight: 600, cursor: 'pointer' },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100, padding: 16 },
  sheet: { background: 'white', borderRadius: 12, padding: '1.5rem', width: 420, maxWidth: '92vw' },
  lbl: { display: 'block', fontSize: '0.85rem', fontWeight: 600, color: '#374151', margin: '0.6rem 0 0.25rem' },
  inp: { width: '100%', padding: '0.5rem 0.7rem', border: '1px solid #d1d5db', borderRadius: 6, boxSizing: 'border-box' },
  check: { display: 'flex', alignItems: 'center', gap: 8, fontSize: '0.9rem', margin: '0.8rem 0' },
  err: { color: '#dc2626', fontSize: '0.85rem' },
  actions: { display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: '1rem' },
  cancel: { background: '#f1f5f9', border: '1px solid #d1d5db', borderRadius: 8, padding: '0.5rem 1rem', cursor: 'pointer' },
}
